import {
  getSyntheticMetricTableValue,
  syntheticByDashboard,
  PostKPM,
  getKPMConfig,
  getErrors,
  getErrorLog,
  getErrorLogs,
  getSMGraphTemplate,
  getAvailability,
  CreateGroupInPulse,
  getSummaryTemplate,
  getSummaryInfoTemplate,
  getAllGroupsListTemplate,
  GetPulseListGroupCards,
  getEndpointDetails,
  DeleteGroupInPulse,
  GetGroupAlerts,
  DeleteEGKPM,
  addingEndpoint,
  fetchEndpointDetails,
  saveScheduleTest,
  pauseResumeAirflow,
  fetchAirflowSchedule,
  getRefreshTestStatuses,
  getTestPlanIdsList,
  getOauthToken,
  saveOauth2Token,
  getAllSecretsListTemplate,
  saveSecretTokenTemplate,
  checkSecretTemplate,
  getTokenLinkedToSecretTemplate,
  deleteSecretTemplate,
  getTokenListTemplate,
  getATokenTemplate,
  deleteTokenTemplate,
  getEndpointListLinkedToTokenTemplate,
  editTokenTemplate,
  getMappedEndpointDetails
} from '../fragments/synthetic';

export const querySyntheticMetricTableValue = `query getSyntheticMetricTableValue(${getSyntheticMetricTableValue.variable}) {${getSyntheticMetricTableValue.query}}`;
export const querySyntheticByDashboard = `query syntheticByDashboard(${syntheticByDashboard.variable}) {${syntheticByDashboard.query}}`;
export const postKPM = `mutation saveOrUpdateKPMMetric(${PostKPM.variable}) {${PostKPM.query}}`;
export const createGroupInPulse = `mutation CreateGroupInPulse(${CreateGroupInPulse.variable}) {${CreateGroupInPulse.query}}`;
export const deleteGroupInPulse = `mutation DeleteGroupInPulse(${DeleteGroupInPulse.variable}) {${DeleteGroupInPulse.query}}`;
export const getGroupAlerts = `query FetchAlertRules(${GetGroupAlerts.variable}) {${GetGroupAlerts.query}}`;
export const deleteEGKPM = `mutation DeleteEGKPM(${DeleteEGKPM.variable}) {${DeleteEGKPM.query}}`;
export const getPulseListGroupCards = `query GetPulseListGroupCards(${GetPulseListGroupCards.variable}) {${GetPulseListGroupCards.query}}`;
export const queryGetKPMConfig = `query getKPMConfig(${getKPMConfig.variable}) {${getKPMConfig.query}}`;
export const getSMErrors = `query queryBrowserErrorSummary(${getErrors.variable}) {${getErrors.query}}`;
export const getSMErrorLogs = `query queryBrowserErrorLogs(${getErrorLogs.variable}) {${getErrorLogs.query}}`;
export const getSMErrorLog = `query queryBrowserErrorLog(${getErrorLog.variable}) {${getErrorLog.query}}`;
export const getSMTemplate = `query getKPMGraphTemplate(${getSMGraphTemplate.variable}) {${getSMGraphTemplate.query}}`;
export const queryGetAvailability = `query getAvailability(${getAvailability.variable}) {${getAvailability.query}}`;
export const getSummaryDataList = `query getSMTemplate(${getSummaryTemplate.variable}) {${getSummaryTemplate.query}}`;
export const getSummaryInfo = `query getSummaryInfoTemplate(${getSummaryInfoTemplate.variable}) {${getSummaryInfoTemplate.query}}`;
export const getAllGroupsList = `query getAllGroups(${getAllGroupsListTemplate.variable}) {${getAllGroupsListTemplate.query}}`;
export const getEndpointDetailsTable = `query getEndpointDetails(${getEndpointDetails.variable}) {${getEndpointDetails.query}}`;
export const addEndpoint = `mutation addingEndpoint(${addingEndpoint.variable}) {${addingEndpoint.query}}`;
export const fetchEndpointDetail = `query fetchEndpointDetails(${fetchEndpointDetails.variable}) {${fetchEndpointDetails.query}}`;
export const postScheduleTest = `mutation scheduleTest(${saveScheduleTest.variable}) {${saveScheduleTest.query}}`;
export const pauseResumeScheduleAirflow = `mutation pauseResumeAirflow(${pauseResumeAirflow.variable}) {${pauseResumeAirflow.query}}`;
export const fetchAirflowScheduleInfo = `query fetchAirflowSchedule(${fetchAirflowSchedule.variable}) {${fetchAirflowSchedule.query}}`;
export const getRefreshTestStatus = `query fetchTestCaseInfo(${getRefreshTestStatuses.variable}) {${getRefreshTestStatuses.query}}`;
export const getTestPlanIds = `query fetchTestCaseInfo(${getTestPlanIdsList.variable}) {${getTestPlanIdsList.query}}`;
export const getAuthToken = `query fetchPulseAuthTokens(${getOauthToken.variable}) {${getOauthToken.query}}`;
export const saveOauthToken = `mutation saveAuthToken(${saveOauth2Token.variable}) {${saveOauth2Token.query}}`;
export const getAllSecretsList = `query getAllSecrets(${getAllSecretsListTemplate.variable}) {${getAllSecretsListTemplate.query}}`;
export const saveSecretToken = `mutation saveSecret(${saveSecretTokenTemplate.variable}) {${saveSecretTokenTemplate.query}}`;
export const validateOauthToken = `query isPresent(${checkSecretTemplate.variable}) {${checkSecretTemplate.query}}`;
export const getTokensLinkedToSecretList = `query getListofTokensLinkedtoSecretId(${getTokenLinkedToSecretTemplate.variable}) {${getTokenLinkedToSecretTemplate.query}}`
export const deleteSecret = `mutation deleteSecret(${deleteSecretTemplate.variable}) {${deleteSecretTemplate.query}}`;
export const getAllTokensList = `query getTokenList(${getTokenListTemplate.variable}) {${getTokenListTemplate.query}}`;
export const getAToken = `query getAToken(${getATokenTemplate.variable}) {${getATokenTemplate.query}}`;
export const deleteToken = `mutation deleteToken(${deleteTokenTemplate.variable}) {${deleteTokenTemplate.query}}`;
export const getEndpointsLinkedToToken = `query getEndpointsLinkedToAToken(${getEndpointListLinkedToTokenTemplate.variable}) {${getEndpointListLinkedToTokenTemplate.query}}`;
export const editToken = `mutation editToken(${editTokenTemplate.variable}) {${editTokenTemplate.query}}`
export const getMappedEndpointDetailsTable = `query getEndpointDetails(${getMappedEndpointDetails.variable}) {${getMappedEndpointDetails.query}}`;
